import { createSlice } from '@reduxjs/toolkit';
import MojitoCore from 'mojito/core';

const reduxInstance = MojitoCore.Services.redux;

/**
 * The name of the market category hint store. Will be used to register in global redux store.
 *
 * @constant
 * @type {string}
 * @memberof Mojito.Modules.EventMarkets
 */
export const STORE_KEY = 'modules/eventMarkets';

/**
 * Defines the state of the market category hint store.
 *
 * @typedef MarketCatHintState
 *
 * @property {string|undefined} marketCat - The market category id to preselect (e.g., 'player_prop').
 *
 * @memberof Mojito.Modules.EventMarkets
 */
export const INITIAL_STATE = {
    marketCat: undefined,
};

export const { reducer, actions } = createSlice({
    name: STORE_KEY,
    initialState: INITIAL_STATE,
    reducers: {
        /**
         * Set the market category hint to preselect on the event page.
         *
         * @param {object} state - Current state.
         * @param {object} action - Action object.
         * @param {string} action.payload - The market category id to preselect (e.g., 'player_prop').
         */
        setMarketCatHint(state, { payload }) {
            state.marketCat = payload;
        },
        /**
         * Clear the market category hint after it has been consumed.
         *
         * @param {object} state - Current state.
         */
        clearMarketCatHint(state) {
            state.marketCat = undefined;
        },
    },
});

reduxInstance.injectReducer(STORE_KEY, reducer);
